import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import localizationIt from 'moment/locale/it';
import localizationEng from 'moment/locale/en-gb';
import moment from 'moment';

import translationGr from './locales/gr/translation.json';
import translationIT from './locales/it/translation.json';
import translationRS from './locales/rs/translation.json';
import translationSP from './locales/sp/translation.json';
import translationENG from './locales/eng/translation.json';

// the translations
const resources = {
  gr: {
    translation: translationGr,
  },
  it: {
    translation: translationIT,
  },
  rs: {
    translation: translationRS,
  },
  sp: {
    translation: translationSP,
  },
  eng: {
    translation: translationENG,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'it',
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, lng) => {
        if (value instanceof Date) {
          lng === 'it'
            ? moment.updateLocale('it', localizationIt)
            : moment.updateLocale('en', localizationEng);
          return format === 'fromNow'
            ? moment(value).fromNow()
            : moment(value).format(format);
        }
        return value;
      },
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
